import React from "react"
import ContentLoader from "react-content-loader"

export const DiaryListViewRightPanelLoader  = props =>{
    return(<>
        {props.count && props.count > 0 && (
                      Array.from({ length: props.count }, (_, i) => (
                <ContentLoader 
                key={i+1}
                speed={2}
                width={960}
                height={610}
                viewBox="0 0 960 610"
                backgroundColor="#f3f3f3"
                foregroundColor="#ecebeb"
            >
                <rect x="479" y="2" rx="8" ry="8" width="117" height="12" /> 
                <rect x="8" y="2" rx="8" ry="8" width="257" height="12" /> 
                <rect x="10" y="38" rx="8" ry="8" width="98" height="12" /> 
                <rect x="127" y="35" rx="8" ry="8" width="98" height="12" /> 
                <rect x="8" y="75" rx="8" ry="8" width="257" height="12" /> 
                <circle cx="20" cy="129" r="13" /> 
                <rect x="47" y="114" rx="8" ry="8" width="158" height="12" /> 
                <rect x="49" y="135" rx="8" ry="8" width="153" height="12" /> 
                <circle cx="351" cy="125" r="15" /> 
                <circle cx="500" cy="124" r="15" /> 
                <rect x="374" y="114" rx="8" ry="8" width="94" height="12" /> 
                <rect x="522" y="114" rx="8" ry="8" width="67" height="12" /> 
                <rect x="14" y="154" rx="8" ry="8" width="168" height="12" /> 
                <rect x="10" y="176" rx="8" ry="8" width="110" height="12" /> 
                <rect x="10" y="213" rx="8" ry="8" width="172" height="12" /> 
                <rect x="13" y="237" rx="8" ry="8" width="125" height="12" /> 
                <rect x="13" y="274" rx="8" ry="8" width="110" height="12" /> 
                <rect x="8" y="307" rx="8" ry="8" width="132" height="12" /> 
                <rect x="153" y="309" rx="8" ry="8" width="90" height="12" /> 
                <rect x="255" y="309" rx="8" ry="8" width="112" height="12" /> 
                <rect x="11" y="359" rx="8" ry="8" width="134" height="12" /> 
                <rect x="16" y="387" rx="8" ry="8" width="54" height="47" /> 
                <rect x="90" y="388" rx="8" ry="8" width="122" height="12" /> 
                <rect x="88" y="419" rx="8" ry="8" width="164" height="12" /> 
                <rect x="13" y="461" rx="8" ry="8" width="198" height="12" /> 
                <rect x="13" y="492" rx="8" ry="8" width="572" height="12" /> 
                <rect x="14" y="520" rx="8" ry="8" width="576" height="12" /> 
                <rect x="18" y="549" rx="8" ry="8" width="574" height="20" /> 
                <rect x="22" y="577" rx="8" ry="8" width="282" height="12" />
            </ContentLoader>
                      ))
                  )}</>)
}

